export const WAREHOUSE_EXPORT_ID = 'warehouse';

export const WAREHOUSE_TITLE = 'Almacenes';

export const LOCALIZED_PROPERTIES = {
  externalKeys: 'Código',
  name: 'Nombre',
  plants: 'Planta',
  company: 'Compañía',
  priceList: 'Lista de Precios',
  discountList: 'Lista de Descuentos',
  status: 'Estado',
  readOnly: 'Solo Lectura',
};
